import o from"./pagination";var a=o;export{a as default};
//# sourceMappingURL=index.js.map
